import { AdminClients } from './AdminClients';

export default AdminClients;